module.exports = __webpack_public_path__ + "img/QuesoFromagerdaffinois.4c4800c7.jpg";